const initialState: sage.state.IBalance = {
    createSaleStatus: "none",
    createOrderStatus: "none",
    createTransferStatus: "none",
    sales: {},
    salesStatus: {},
    orders: {},
    ordersStatus: {},
    moneyEntries: {},
    moneyEntriesStatus: {},
    transfers: {},
    transfersStatus: {},
    marketPriceStatus: "none",
    marketPrice: null,
    addMoneyStatus: "none",
    cancelOrderStatus: {},
    cancelSaleStatus: {},
};

export default function balance(
    state: sage.state.IBalance = initialState,
    action: sage.actions.balance.ReducerTypes
): sage.state.IBalance {
    switch (action.type) {
        case "com.sage.actions.balance.setCreateSaleStatus":
            return {
                ...state,
                createSaleStatus: action.status,
            };
        case "com.sage.actions.balance.ISetSales":
            return {
                ...state,
                sales: {
                    ...state.sales,
                    [action.page]: action.sales,
                },
            };
        case "com.sage.actions.balance.ISetSalesStatus":
            return {
                ...state,
                salesStatus: {
                    ...state.salesStatus,
                    [action.page]: action.status,
                },
            };
        case "com.sage.actions.balance.IResetSalesFetch":
            return {
                ...state,
                salesStatus: {},
                sales: {},
            };
        case "com.sage.actions.balance.ISetCreateOrderStatus":
            return {
                ...state,
                createOrderStatus: action.status,
            };
        case "com.sage.actions.balance.IResetOrdersFetch":
            return {
                ...state,
                orders: {},
                ordersStatus: {},
            };
        case "com.sage.actions.balance.ISetOrders":
            return {
                ...state,
                orders: {
                    [action.page]: action.orders,
                },
            };
        case "com.sage.actions.balance.ISetOrdersStatus":
            return {
                ...state,
                ordersStatus: {
                    [action.page]: action.status,
                },
            };
        case "com.sage.actions.balance.IResetMoneyEntriesFetch":
            return {
                ...state,
                moneyEntries: {},
                moneyEntriesStatus: {},
            };
        case "com.sage.actions.balance.ISetMoneyEntries":
            return {
                ...state,
                moneyEntries: {
                    ...state.moneyEntries,
                    [action.page]: action.moneyEntries,
                },
            };
        case "com.sage.actions.balance.ISetMoneyEntriesStatus":
            return {
                ...state,
                moneyEntriesStatus: {
                    ...state.moneyEntriesStatus,
                    [action.page]: action.status,
                },
            };
        case "com.sage.actions.balance.IResetTransfersFetch":
            return {
                ...state,
                transfers: {},
                transfersStatus: {},
            };
        case "com.sage.actions.balance.ISetCreateTransferStatus":
            return {
                ...state,
                createTransferStatus: action.status,
            };
        case "com.sage.actions.balance.ISetTransfers":
            return {
                ...state,
                transfers: {
                    ...state.transfers,
                    [action.page]: action.transfers,
                },
            };
        case "com.sage.actions.balance.ISetFetchTransfersStatus":
            return {
                ...state,
                transfersStatus: {
                    ...state.transfersStatus,
                    [action.page]: action.status,
                },
            };
        case "com.sage.actions.balance.ISetMarketPrice":
            return {
                ...state,
                marketPrice: action.marketPrice,
            };
        case "com.sage.actions.balance.ISetMarketPriceStatus":
            return {
                ...state,
                marketPriceStatus: action.status,
            };
        case "com.sage.actions.balance.ISetAddMoneyStatus":
            return {
                ...state,
                addMoneyStatus: action.status,
            };
        case "com.sage.actions.balance.ICancelOrderStatus":
            return {
                ...state,
                cancelOrderStatus: {
                    ...state.cancelOrderStatus,
                    [action.orderId]: action.status,
                },
            };
        case "com.sage.actions.balance.ISetCancelSaleStatus":
            return {
                ...state,
                cancelSaleStatus: {
                    ...state.cancelSaleStatus,
                    [action.saleId]: action.status,
                },
            };
        case "com.sage.actions.balance.IClear":
            return initialState;
        default:
            return state;
    }
}
